import { render, staticRenderFns } from "./stu_sign.vue?vue&type=template&id=3edc235d&scoped=true"
import script from "./stu_sign.vue?vue&type=script&lang=js"
export * from "./stu_sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc235d",
  null
  
)

export default component.exports